import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import CircleCiderText from '../../common/components/svg/CircleCiderText';
import useFlavorStore from '../../common/store/useFlavorStore';

export const Wrapper = styled.div`
  position: relative;
`;

const Image = styled.img`
  aspect-ratio: 147/120;
  width: 100%;
  height: auto;
`;

const SVGContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%) rotate(6.5deg);

  aspect-ratio: 1/1;
  width: 140%;
  height: auto;
`;

const Logo = ({ circleRef }: { circleRef?: React.RefObject<SVGSVGElement> }) => {

  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  return (
    <Wrapper>
      <Image src={`/static/images/logo/${flavor}.png`} />

      <SVGContainer>
        <CircleCiderText ref={circleRef} />
      </SVGContainer>
    </Wrapper>
  );
}

export default Logo;